export default __webpack_public_path__ + "fonts/ivritacons-alefalefalef.woff2";